/* eslint-disable no-nested-ternary */
import React from 'react';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { priceFormatter } from '../../../../../utils/formatters';
import { capitalizeEachWord, getTotalCosts } from '../../../../../utils/utils';
import { Order } from '../../../../../Models';
import { OrderSection } from '../OrderSection';

const subHeaderStyle = {
    backgroundColor: 'grey.100',
};
export function OfferCard({ order }: { order: Order }) {
    const userOffer = order.user_offer;
    const chargedTotal = getTotalCosts(userOffer);
    return (
        <OrderSection id="order-summary-data">
            <Stack
                direction="column"
                justifyContent="space-between"
                spacing={2}
                divider={<Divider flexItem />}>
                <Stack direction="row" justifyContent="start" alignItems="center" spacing={1}>
                    <ReceiptIcon color="action" />
                    <Typography variant="h6" fontWeight="medium">
                        Resumen
                    </Typography>
                </Stack>
                <TableContainer id="order-summary-table" sx={{ p: 0 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Producto</TableCell>
                                <TableCell align="right">Cantidad</TableCell>
                                <TableCell align="right">Precio Unitario</TableCell>
                                <TableCell align="right">Dto.</TableCell>
                                <TableCell align="right">Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {userOffer?.products?.map((prod) => (
                                <TableRow key={prod.name}>
                                    <TableCell>{capitalizeEachWord(prod.name)}</TableCell>
                                    <TableCell align="right">{prod.quantity}</TableCell>
                                    <TableCell align="right">
                                        {priceFormatter.format(prod.unit_price / 100)}
                                    </TableCell>
                                    <TableCell align="right">
                                        {prod.discount_percent || 0}%
                                    </TableCell>
                                    <TableCell align="right">
                                        {priceFormatter.format(
                                            (prod.quantity *
                                                prod.unit_price *
                                                (1 - (prod.discount_percent || 0) / 100)) /
                                                100,
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                            {(!userOffer?.products || userOffer.products.length === 0) && (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        No hay productos
                                    </TableCell>
                                </TableRow>
                            )}
                            <TableRow sx={subHeaderStyle}>
                                <TableCell align="left" colSpan={4} sx={{ fontWeight: 'medium' }}>
                                    Total
                                </TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'medium' }}>
                                    {priceFormatter.format(chargedTotal)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Stack>
        </OrderSection>
    );
}
